import proxyInstance from "src/config/api/proxyInstance";

export const setRxoVisit = (id: string) =>
  proxyInstance.put("/rxo/first_visit", {}, { params: { rxo_uuid: id } });
